export { default } from "./DocLink";
